var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.973635 11.7988H13.9522C14.4893 11.7988 14.9258 11.3623 14.9258 10.8252V8.62803H10.267C9.91809 8.62803 9.57732 8.55989 9.25764 8.42356C8.94933 8.29375 8.67184 8.10551 8.43492 7.86861C8.198 7.63169 8.00977 7.35419 7.87995 7.04587C7.74527 6.72619 7.67549 6.38542 7.67549 6.03654V5.76229C7.67549 5.41341 7.74364 5.07264 7.87995 4.75296C8.00977 4.44464 8.19802 4.16716 8.43492 3.93024C8.67186 3.69332 8.94933 3.50509 9.25764 3.37527C9.57732 3.24058 9.91809 3.1708 10.267 3.1708H14.9258V0.973635C14.9258 0.436513 14.4893 0 13.9522 0H0.973635C0.436513 0 0 0.436513 0 0.973635V10.8252C0 11.3623 0.436513 11.7988 0.973635 11.7988Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 4.87451C15.9999 4.47045 15.6737 4.14429 15.2696 4.14429H14.9256H10.2668C9.37264 4.14429 8.64893 4.86802 8.64893 5.76214V6.03638C8.64893 6.93051 9.37266 7.65422 10.2668 7.65422H14.9256H15.2696C15.6737 7.65422 15.9999 7.32806 15.9999 6.924V4.87451ZM10.5313 6.7585C10.0558 6.7585 9.67124 6.37393 9.67124 5.89845C9.67124 5.42299 10.0558 5.03841 10.5313 5.03841C11.0067 5.03841 11.3913 5.42299 11.3913 5.89845C11.3913 6.37393 11.0067 6.7585 10.5313 6.7585Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.f255a88d.svg";
export { ForwardRef as ReactComponent };